import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class LayeredModules {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);

		const panels = document.querySelectorAll('.panel');

		const siblings = [...panels].map((panel) => {
			return panel.previousElementSibling;
		});

		siblings.forEach((panel, i) => {
			let start = 'top top';
			const panelHeight = panel.offsetHeight;
			const viewportHeight = window.innerHeight;
			if (panelHeight > viewportHeight) {
				start = 'bottom bottom';
			}

			const createdPanel = ScrollTrigger.create({
				trigger: panel,
				start: start,
				pin: true,
				pinSpacing: false,
				onUpdate: self => {
					self.trigger.querySelector('.container').style.opacity = 1 - self.progress;
				}				
			});
			createdPanel.spacer.classList.add('panel-' + (i + 1));
		});
	}
}
